export default __webpack_public_path__ + "static/media/ceramol-iage-result-freedom-lover.b5e1a730.png";